import React from 'react'
import List from 'material-ui/List'
import Divider from 'material-ui/Divider';
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft';
import ChevronRightIcon from 'material-ui-icons/ChevronRight';
import IconButton from 'material-ui/IconButton';
import Hidden from 'material-ui/Hidden';
import {connect} from 'react-redux'
import celulaActions, {selectLabelDescriptions} from '../Redux/celulaRedux'
import Autocomplete from './Autocomplete'
import { withStyles } from 'material-ui/styles';
import filterActions from '../Redux/filterRedux'
import Button from 'material-ui/Button';
import { compose } from "recompose"
import GileadeDrawerItem from './GileadeDrawerItem'
import {selectIgrejas} from '../Redux/igrejaRedux'

const styles = theme => ({
  filtrarButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 15
  },
  filtrarButton: {
    width: '100%'
  },
  drawerHeader: theme.mixins.toolbar,
  root: {
    height: '100%',
    display: 'flex'
  },
  drawerPaper: {
    width: 250,
    [theme.breakpoints.up('md')]: {
      width: 240,
      position: 'relative',
      height: '100%'
    },
  }
})




const GileadeDrawerContent = ({classes, doFilter, theme, onBackPress, items, igrejas, filter, change}) => (
  <div className={classes.drawerInner}>
    <div className={classes.drawerHeader}>
      <Hidden mdUp>
        <IconButton onClick={onBackPress}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Hidden>
    </div>
    <div style={{paddingLeft: 15, paddingRight: 15}}>
      <Autocomplete
        placeholder=''
        label='Selecione uma Igreja'
        value={filter.igreja}
        onChange={change('igreja')}
        suggestions={igrejas}/>
    </div>
    <div className={classes.filtrarButtonContainer}>
      <Button
        className={classes.filtrarButton}
        onClick={doFilter}
        raised={true}
        color="primary" >
        Filtrar
      </Button>
    </div>
    <Divider />
    <List className={classes.list}>
      <GileadeDrawerItem
        noIcon
        value=''
        text='Ver Todas'/>
      {
        items.map((item, index) =>
          <GileadeDrawerItem
            key={index}
            color={item.color}
            value={item.description}
            text={item.description}/>
        )
      }
    </List>
    <Divider />
  </div>
)

const mapStateToProps = state => ({
  filter: state.filter,
  items: selectLabelDescriptions(state),
  igrejas: selectIgrejas(state).map(i => ({key: i.id, label: i.descricao}))
})

const mapDispatchToProps = dispatch => ({
  change: key => values => dispatch(filterActions.change({[key]: values})),
  doFilter: () => dispatch(celulaActions.filter())
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles, { withTheme: true })
)(GileadeDrawerContent)



// WEBPACK FOOTER //
// ./src/Components/GileadeDrawerContent.js